import { render, staticRenderFns } from "./NewCourseInfo.vue?vue&type=template&id=5f13271b&scoped=true&"
import script from "./NewCourseInfo.vue?vue&type=script&lang=js&"
export * from "./NewCourseInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewCourseInfo.vue?vue&type=style&index=0&id=5f13271b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13271b",
  null
  
)

export default component.exports